import { Box } from "@mui/material";
import { styled } from "styled-components";

export const ContentList = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 4px;
  flex: 1;
  min-height: 0;
`;

export const ContentReadAll = styled(Box)`
  height: 30px;
  width: 100%;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
`;

export const ContentReadAllRight = styled(Box)`
  right: 0;
`;

export const ContentReadAllLeft = styled(Box)`
  left: 0;
`;
